import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import BrnadList from '@features/crm/brands/components/BrnadList';
import BDMList from '@features/crm/brands/components/BDMList';
import BrandBasicInfo from '@features/crm/brands/components/BrandBasicInfo';
import BrandCertificates from '@features/crm/brands/components/BrandCertificates';
import BrandIntroduction from '@features/crm/brands/components/BrandIntroduction';
import BrandMarketStatus from '@features/crm/brands/components/BrandMarketStatus';
import BrandOverview from '@features/crm/brands/components/BrandOverview';
import BrandStyles from '@features/crm/brands/components/BrandStyles';
import BrandWiseSupplierList from '@features/crm/brands/components/BrandWiseSupplierList';
import DepartmentAndCategories from '@features/crm/brands/components/DepartmentAndCategories';
import NitexOperationTeam from '@features/crm/brands/components/NitexOperationTeam';
import Pricing from '@features/crm/brands/components/pricing/Pricing';
import { brandTabs } from '@features/crm/utils/helpers';

import { fetchBrandProfileById } from '@store/actions/BrandProfileAction';

import { checkAnyUserType } from '@utils/Util';

const BrandProfile = () => {
	const {
		OVERVIEW,
		ABOUT,
		MARKET_STATUS,
		STYLES,
		DEPARTMENT_CATEGORIES,
		BRAND_TEAM,
		NITEX_OPS_TEAM,
		REQUIRED_CERTIFICATES,
		SUPPLIER,
		BUYER_AND_BDM,
		PRICING
	} = brandTabs;

	const [activeTab, setActiveTab] = useState(OVERVIEW);
	const [selectedBrandTeam, setSelectedBrandTeam] = useState(null);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchBrandProfileById(`${id}`));
	}, []);

	const onTabChange = (value) => {
		setActiveTab(value);
	};

	const onSetBrandTeam = (value) => {
		setSelectedBrandTeam(value);
	};

	const renderTabContents = () => {
		switch (activeTab) {
			case OVERVIEW:
				return <BrandOverview />;
			case ABOUT:
				return <BrandBasicInfo />;
			case MARKET_STATUS:
				return <BrandMarketStatus />;
			case STYLES:
				return <BrandStyles />;
			case DEPARTMENT_CATEGORIES:
				return <DepartmentAndCategories />;
			case NITEX_OPS_TEAM:
				return <NitexOperationTeam />;
			case BRAND_TEAM:
				return (
					<BrnadList
						onTabChange={(value) => {
							onSetBrandTeam(value);
							onTabChange('BUYER_AND_BDM');
						}}
					/>
				);
			case BUYER_AND_BDM:
				return (
					<BDMList
						teamInfo={selectedBrandTeam}
						onTabChange={() => {
							onSetBrandTeam(null);
							onTabChange('BRAND_TEAM');
						}}
					/>
				);
			case SUPPLIER:
				return <BrandWiseSupplierList />;
			case REQUIRED_CERTIFICATES:
				return <BrandCertificates />;
			case PRICING:
				return <Pricing />;
			default:
				return <></>;
		}
	};

	return (
		<section className="body-content scroll-x-label">
			<div className="brand-profile-container">
				<BrandIntroduction />

				<div className="brand-overview-with-tab">
					<div className="brand-tab-container">
						<ul className="brand-tab cursor-pointer scroll-x-label">
							<li
								onClick={() => onTabChange(OVERVIEW)}
								className={activeTab === OVERVIEW ? 'active' : ''}
							>
								Overview
							</li>
							<li
								onClick={() => onTabChange(ABOUT)}
								className={activeTab === ABOUT ? 'active' : ''}
							>
								About
							</li>
							<li
								onClick={() => onTabChange(MARKET_STATUS)}
								className={activeTab === MARKET_STATUS ? 'active' : ''}
							>
								Market Status
							</li>

							<li
								onClick={() => onTabChange(DEPARTMENT_CATEGORIES)}
								className={activeTab === DEPARTMENT_CATEGORIES ? 'active' : ''}
							>
								Insights
							</li>
							<li
								onClick={() => onTabChange(NITEX_OPS_TEAM)}
								className={activeTab === NITEX_OPS_TEAM ? 'active' : ''}
							>
								Nitex Ops Team
							</li>
							<li
								onClick={() => onTabChange(BRAND_TEAM)}
								className={activeTab === BRAND_TEAM ? 'active' : ''}
							>
								Brand Team
							</li>
							<li
								onClick={() => onTabChange(SUPPLIER)}
								className={activeTab === SUPPLIER ? 'active' : ''}
							>
								Supplier
							</li>
							<li
								onClick={() => onTabChange(REQUIRED_CERTIFICATES)}
								className={activeTab === REQUIRED_CERTIFICATES ? 'active' : ''}
							>
								Required Certificates
							</li>
							{checkAnyUserType(['ADMIN', 'ACCOUNT_MANAGER']) && (
								<li
									onClick={() => onTabChange(PRICING)}
									className={activeTab === PRICING ? 'active' : ''}
								>
									Pricing
								</li>
							)}
						</ul>
						{renderTabContents()}
					</div>
				</div>
			</div>
		</section>
	);
};

export default BrandProfile;
